module.exports = __webpack_public_path__ + "media/images/benefit-05-1b33c2cd13ae3263440280820ea8b825.svg";